export enum DomElementId {
  PrepageRoot = 'cabal-prepage-root',
}
